export enum ProductPriceType {
  /**
   * Базовая цена
   * Высчитывается на бэкенде в зависимости от роли и статуса
   * Всегда указывает на один из типов цен ниже
   */
  BASE = 'base',

  /**
   * Розничная цена
   */
  RETAIL = 'retail',

  /**
   * Мелкооптовая цена
   */
  SMALL_WHOLESALE = 'small_wholesale',

  /**
   * Партнёрская цена
   */

  PARTNER = 'partner',

  /**
   * Цена мастер-партнёр (МП)
   */
  MASTER_PARTNER = 'master_partner',

  /**
   * Цена премиум-партнёр (ПП)
   */
  PREMIUM_PARTNER = 'partner_partner',

  /**
   * Цена дистрибьютора
   */
  DISTRIBUTOR = 'distributor',

  /**
   * Цена распродажи
   */
  SELL_OUT = 'sell_out',
}

export const ProductPriceTypeTranslate: Record<ProductPriceType, string> = {
  [ProductPriceType.BASE]: '',
  [ProductPriceType.RETAIL]: 'Розничная',
  [ProductPriceType.SMALL_WHOLESALE]: 'Мелкооптовая',
  [ProductPriceType.PARTNER]: 'Бронза',
  [ProductPriceType.MASTER_PARTNER]: 'Мастер-партнёр',
  [ProductPriceType.PREMIUM_PARTNER]: 'Серебро',
  [ProductPriceType.DISTRIBUTOR]: 'Золото',
  [ProductPriceType.SELL_OUT]: 'Цена распродажи',
};
